import { useEffect, useRef } from "react";

const POLL_INTERVAL_MS = 10_000;

/**
 * Polls `onPoll` every POLL_INTERVAL_MS while `active` is true, and stops
 * automatically otherwise. Intended for re-fetching a propitious-area job
 * list while it still holds QUEUED/RUNNING jobs — callers compute `active`
 * from the current list and pass it in.
 */
export function usePropitiousAreaJobsPolling(
  active: boolean,
  onPoll: () => void
): void {
  const onPollRef = useRef(onPoll);
  onPollRef.current = onPoll;

  useEffect(() => {
    if (!active) return;
    const intervalId = setInterval(() => {
      onPollRef.current();
    }, POLL_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [active]);
}
